import React, { useState, useEffect } from "react";
import { Card, Col, Row, Typography, Table, Tag } from "antd";
import { Link } from 'react-router-dom';
import { PRICE } from "../../constants/conts";
import useRequest from "../../hooks/useRequest";
import { NavLink, useLocation } from "react-router-dom";
import { ShowToast, Severty } from "../../helper/toast";
import moment from 'moment';
import apiPath from "../../constants/apiPath";
import Logo from "../../assets/images/Logo.png";

function Home() {

  const { Title, Text } = Typography;
  const { request } = useRequest()
  const [loading, setLoading] = useState(false)
  const [requestQuotesList, setRequestQuotesList] = useState([])

  const [dashboard, setDashboard] = useState({
    customerCount: 0,
    specialistCount: 0,
    dealerCount: 0,
    typeCount: 0,
    makeCount: 0,
    modelCount: 0,
    variantCount: 0,
    productSaleCount: 0,
    productCatalogueCount: 0,
    requestQuoteCount: 0,
  })

  const count = [
    {
      today: "Number of Users",
      title: `${dashboard && dashboard.customerCount ? dashboard.customerCount : 0}`,
      persent: "10%",
      icon: <i class="fas fa-user-friends"></i>,
      bnb: "bnb2",
      url: '/pimptup-admin/user/customer'
    },
    {
      today: "Number of Dealers",
      title: `${dashboard && dashboard.dealerCount ? dashboard.dealerCount : 0}`,
      icon: <i class="fas fa-people-carry"></i>,
      bnb: "bnb2",
      url: '/pimptup-admin/user/dealer'
    },
    {
      today: "Number of Specialists",
      title: `${dashboard && dashboard.specialistCount ? dashboard.specialistCount : 0}`,
      icon: <i class="fas fa-user-tie"></i>,
      bnb: "bnb2",
      url: '/pimptup-admin/user/specialist'
    },
    // {
    //   today: "Number of Types",
    //   title: `${dashboard && dashboard.typeCount ? dashboard.typeCount : 0}`,
    //   icon: <i className="fa fa-car"></i>,
    //   bnb: "bnb2",
    //   url: '/pimptup-admin/vehicle/type'
    // },
    {
      today: "Number of Makes",
      title: `${dashboard && dashboard.makeCount ? dashboard.makeCount : 0}`,
      icon: <i class="fas fa-copyright"></i>,
      bnb: "bnb2",
      url: '/pimptup-admin/vehicle/make'
    },
    // {
    //   today: "Number of Models",
    //   title: `${dashboard && dashboard.modelCount ? dashboard.modelCount : 0}`,
    //   icon: <i className="fa fa-car"></i>,
    //   bnb: "bnb2",
    //   url: '/pimptup-admin/vehicle/model'
    // },
    {
      today: "Number of Variants",
      title: `${dashboard && dashboard.variantCount ? dashboard.variantCount : 0}`,
      icon: <i className="fa fa-car"></i>,
      bnb: "bnb2",
      url: '/pimptup-admin/vehicle/variant'
    },
    {
      today: "Number of Product in Catalogue",
      title: `${dashboard && dashboard.productCatalogueCount ? dashboard.productCatalogueCount : 0}`,
      icon: <i className="fab fa-product-hunt"></i>,
      bnb: "bnb2",
      url: '/pimptup-admin/product/catalogue'
    },
    {
      today: "Number of Request for Quotes",
      title: `${dashboard && dashboard.requestQuoteCount ? dashboard.requestQuoteCount : 0}`,
      icon: <i class="fas fa-quote-right"></i>,
      bnb: "bnb2",
      url: '/pimptup-admin/quote?tab=request'
    },
    {
      today: "Number of Quotes Fulfilled",
      title: `${dashboard && dashboard.fulfilledQuoteCount ? dashboard.fulfilledQuoteCount : 0}`,
      icon: <i class="fas fa-quote-right"></i>,
      bnb: "bnb2",
      url: '/pimptup-admin/quote?tab=received'
    },
    {
      today: "Number of Quotes Replied",
      title: `${dashboard && dashboard.repliedQuoteCount ? dashboard.repliedQuoteCount : 0}`,
      icon: <i class="fas fa-quote-right"></i>,
      bnb: "bnb2",
      url: '/pimptup-admin/quote?tab=fulfill'
    },
  ];

  const requestQuotesColumns = [
    {
      title: "Customer Name",
      render: (_, { user_id }) => {
        return user_id ? <a target="_blank" rel="noreferrer noopener" className="cap" href={`/user/customer/view/${user_id._id}`}>{(user_id ? user_id.name : '-')}</a> : '-';
      },
    },
    {
      title: "Category",
      dataIndex: "category_id",
      key: "category_id",
      render: (_, { category_id }) => {
        return category_id ? <span className="cap">{category_id.name}</span> : '-';
      },
    },
    {
      title: "Part Number",
      dataIndex: "part_number",
      key: "part_number",
      render: (_, { part_number, _id }) => {
        return part_number ? part_number : '-';
      },
    },
    {
      title: "Part Type",
      dataIndex: "part_type",
      key: "part_type",
      render: (_, { part_type }) => {
        return part_type ? <span className="cap">{part_type}</span> : '-';
      },
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      render: (_, { location }) => {
        return location ? <span className="cap">{location}</span> : '-';
      },
    },
    {
      title: "Amount (" + PRICE + ")",
      dataIndex: "amount",
      key: "amount",
      render: (_, { amount }) => {
        return amount ? amount : '-';
      },
    },
    {
      title: "Status",
      key: "status",
      render: (_, { status, _id }) => {
        let color = status === "complete" ? "green" : status === "request" ? "yellow" : status === "receive" ? "blue" : "magenta";
        return (
          <a><Tag onClick={(e) => !(status === "complete") ? /* changeStatus(_id) */ null : null} color={color} key={status}>
            {
              status === "request" ? "Request" :
                status === "receive" ? "Received" :
                  status === "complete" ? "Requirement FullFilled" : null
            }
          </Tag></a>
        );
      },
    },
    {
      title: "Quote On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return (
          moment(created_at).format('DD-MMM-YYYY')
        );
      },
    },
  ];


  useEffect(() => {
    setLoading(true)
    request({
      url: apiPath.dashboard,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false)
        setDashboard(data.data)
        setRequestQuotesList(data?.data.requestedQuoteList)
      },
      onError: (error) => {
        setLoading(false)
        ShowToast(error, Severty.ERROR)
      }
    })
  }, [])

  return (
    <>
      <div className="layout-content">

        <div className="mb-24">
          <Row gutter={[24, 0]}>
            <Col xs={24} sm={6} md={3} className="logoOuterMain">
              <div className="logoOuter"> <img src={Logo} alt="Logo" /> </div>
            </Col>

            <Col xs={24} sm={18} md={21}>
              <Row className="rowgap-vbox" gutter={[24, 16]} style={{ marginLeft: "0" }}>
                {count.map((c, index) => (
                  <Col key={index} xs={24} sm={24} md={12} lg={12} xl={8} xxl={6} className="mb24" style={{ paddingRight: "0px" }}>
                    <Link to={c.url}>
                      <Card bordered={false} className="criclebox" style={{ height: "100%" }}>
                        <div className="number">
                          <Row align="middle" gutter={[24, 0]}>
                            <Col xs={18}>

                              <span>{c.today}</span>
                              <Title level={3}>{c.title}</Title>

                            </Col>
                            <Col xs={6}> <div className="icon-box">{c.icon}</div></Col>
                          </Row>
                        </div>
                      </Card>
                    </Link>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </div>

        <Row className="mt-3" gutter={[24, 0]}>
          <Col span={24}>
            <Card bordered={false} className="criclebox tablespace mb-24"><p className="dashboard-table-heading">Recent Requested (10) Quotes </p>
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={requestQuotesColumns}
                  dataSource={requestQuotesList}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>

      </div>
    </>
  );
}

export default Home;
